import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "492afeb6-e737-4d0f-9c5a-060e19d8d968",
    content:
      "Equalization can be used to make artificial head recordings comparable to those of measurement microphones",
    options: {},
  },
  { id: "b54d3d5a-3a7e-4095-b35e-cac71ed320d0", content: "Only cheap devices require equalization", options: {} },
  {
    id: "bbf472a8-12c0-44b6-9c0c-13366d723cd3",
    content: "Equalization can remove unwanted changes to a sound introduced by the playback device",
    options: {},
  },
  {
    id: "7727bac5-b03e-41b5-9cb1-14e395e1857c",
    content: "Equalization is required to ensure correct binaural playback",
    options: {},
  },
  {
    id: "41596c88-a65c-446a-84d2-dda7203a6ca9",
    content: "Equalization always ensures a flat frequency response",
    options: {},
  },
  {
    id: "4da0cf55-36ad-458d-a92a-07a0593d70ab",
    content: "Individual differences between devices can be compensated through equalization",
    options: {},
  },
];

export const task: Task = {
  id: "fdd58dff-2c78-477f-be78-dd5fc43d0033",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "492afeb6-e737-4d0f-9c5a-060e19d8d968",
    "bbf472a8-12c0-44b6-9c0c-13366d723cd3",
    "7727bac5-b03e-41b5-9cb1-14e395e1857c",
    "4da0cf55-36ad-458d-a92a-07a0593d70ab",
  ],
};
